module.exports = __webpack_public_path__ + "assets/img/16_1741_big.d0b986f9.jpg";